import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const About = () => {
  return (
    <div className="pt-10 pb-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl font-serif font-bold text-navy-900 mb-6"
          >
            Story of Purpose.
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-xl text-slate-600 leading-relaxed"
          >
            From frontline care to senior leadership. A mission to bring strategic leadership and operational clarity to the sector.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="sticky top-28">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/ba94756da441093814cfe3ceab57db9a070deed6a3cd4fa7be0058ed1320fa8aecce39965b827539d337d47996686592/images/aW1hZ2UvanBlZw==/48bdda496d37ccf8f101864e55cc4834.jpeg" 
                alt="Yeukai Kajidori" 
                className="w-full h-auto rounded-xl shadow-2xl mb-8"
              />
              <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                <h3 className="font-serif font-bold text-navy-900 text-xl mb-4">Credentials</h3>
                <ul className="space-y-3 text-sm text-slate-600">
                  <li className="flex items-start gap-2">
                    <SafeIcon name="CheckCircle" className="w-5 h-5 text-gold-500 shrink-0" />
                    <span>MBA & Level 7 Diplomas</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <SafeIcon name="CheckCircle" className="w-5 h-5 text-gold-500 shrink-0" />
                    <span>Former CQC Registered Manager</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <SafeIcon name="CheckCircle" className="w-5 h-5 text-gold-500 shrink-0" />
                    <span>Secured £2.5M+ in Contracts</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 prose prose-lg prose-slate max-w-none">
            <h2 className="text-3xl font-serif font-bold text-navy-900 mb-6">The Journey</h2>
            <p>
              My career did not begin in a boardroom; it began on the frontline. Walking the path from Support Worker to Senior Leadership has given me a 360-degree view of the sector's unique pressures and systemic flaws.
            </p>
            <p>
              I have felt the weight of CQC inspections, the stress of staffing shortages, and the challenge of balancing financial sustainability with the delivery of compassionate, high-quality care. This journey forged my belief that excellence is the result of intentional, world-class systems.
            </p>

            <div className="my-12 p-8 bg-navy-900 text-white rounded-xl relative overflow-hidden">
              <SafeIcon name="Quote" className="absolute top-4 right-4 w-24 h-24 text-white/5" />
              <h3 className="text-2xl font-serif font-bold text-gold-500 mb-4 mt-0">The Philosophy</h3>
              <p className="text-slate-300 m-0 leading-relaxed font-medium">
                "My approach is faith-led, people-first, and systems-thinking. We build robust, sustainable frameworks that transform organisations from the inside out."
              </p>
            </div>

            <h2 className="text-3xl font-serif font-bold text-navy-900 mb-6">The Combined Operating System</h2>
            <p>
              Developed through years of turnarounds and business expansions, my Combined Operating System is the bedrock of The Kajidori Collective. It is a proprietary framework designed to align operational delivery, compliance standards, and leadership vision.
            </p>

            <h2 className="text-3xl font-serif font-bold text-navy-900 mt-12 mb-6">The 'Why'</h2>
            <p>
              My mission is simple: to bring <strong>strategic leadership, operational clarity, and world-class excellence</strong> to the organisations that care for our most vulnerable. When leadership is clear and systems are robust, the quality of care naturally elevates.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;